export class clientModel 
{
     public id:string;
     public name:string;
     public userName:string;
}